import React from "react";
import { cn } from "@/shared/utils/shadcn";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/shared/ui/HoverCard";
import { DimensionCard } from "@/shared/widgets/DimensionCard";
import { useDictionary } from "@/shared/hooks/content/useDictionary";
import { PersonScore } from "@/features/people/hooks/useDimensionsWithScores";

interface DimensionTagProps {
  dim_id: number;
  label: string;
  score?: PersonScore;
  scores?: PersonScore[];
  group: string;
}

const getScoreMultiplier = (group: string) => {
  if (group === "opq") {
    return 10;
  }
  return 1;
};

const DimensionTag: React.FC<DimensionTagProps> = ({
  dim_id,
  label,
  score,
  group,
  scores,
}) => {
  const { getTerm } = useDictionary();
  const tagsClasses = {
    values:
      "text-orange-500 border border-orange-500 hover:bg-orange-500 hover:text-white hover:border-orange-500",
    personality:
      "text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white hover:border-blue-500",
    competencies:
      "text-green-500 border border-green-500 hover:bg-green-500 hover:text-white hover:border-green-500",
    opq: "text-green-500 border border-green-500 hover:bg-green-500 hover:text-white hover:border-green-500",
    hogan:
      "text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white hover:border-blue-500",
    default:
      "text-gray-500 border border-gray-500 hover:bg-gray-500 hover:text-white hover:border-gray-500",
  };

  const title = getTerm(dim_id, "name") || "";
  const description = getTerm(dim_id, "description") || "";

  return (
    <HoverCard openDelay={0} closeDelay={100}>
      <HoverCardTrigger asChild>
        <span
          className={cn(
            "cursor-pointer text-sm font-light px-2 py-0.5 rounded-full print:text-sm mx-0.5",
            tagsClasses[group as keyof typeof tagsClasses] ||
              tagsClasses.default
          )}
        >
          {label?.toLowerCase() || ""}
        </span>
      </HoverCardTrigger>
      <HoverCardContent>
        <DimensionCard
          title={title || " "}
          description={description || ""}
          scores={scores || []}
          showAverageScore={false}
          showScore
          score={score}
          id={dim_id}
          scoreMultiplier={getScoreMultiplier(group)}
        />
      </HoverCardContent>
    </HoverCard>
  );
};

export default DimensionTag;
